import React from "react";
import { useSelector } from "react-redux";
import { selectSequenceOfOperations, selectPumpDetails } from "../../../redux/selectors";

const PrintSequenceOfOperations = () => {
  const sequenceDetails = useSelector(selectSequenceOfOperations);
  const pumpDetails = useSelector(selectPumpDetails);
  const getJockeySequence = (zone) => {
    // First try to find a pump with PumpID of "Jockey" in the specified zone
    const jockeyPump = pumpDetails.find(
      (detail) => detail.PumpID && detail.PumpID.toLowerCase() === "jockey" && detail.Zone === zone
    );
    
    if (jockeyPump) {
      return jockeyPump.JockeySequence || "";
    }
    
    // If not found, look for any pump with JockeySequence defined in the specified zone
    const withJockeySequence = pumpDetails.find(
      (detail) => detail.JockeySequence && detail.Zone === zone
    );
    
    if (withJockeySequence) {
      return withJockeySequence.JockeySequence || "";
    }
    
    // If not found, look for a pump with PumpID of "Main" in the specified zone
    const mainPump = pumpDetails.find(
      (detail) => detail.PumpID && detail.PumpID.toLowerCase() === "main" && detail.Zone === zone
    );
    
    if (mainPump) {
      return mainPump.JockeySequence || "";
    }
    
    // If no matching pump found, return empty string
    return "";
  };

  const isZoneEmpty = (detail) => {
    return (
      !detail.AlarmOne &&
      !detail.AlarmTwo &&
      !detail.AlarmThree &&
      !detail.AlarmFour &&
      !detail.Type &&
      !getJockeySequence(detail.Zone) &&
      !detail.Comments
    );
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    return (
      <div>
        {details
          .filter(detail => detail && Object.keys(detail).length > 0)
          .map((detail, index) => {
            if (isZoneEmpty(detail)) {
              return null;
            }
            return (
              <div className="section" key={index}>
                <h3 className="print-zone-label">Zone: {detail.Zone}</h3>
                <table className="table table-bordered full-width">
                  <tbody>
                    <tr>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr><td><strong>Alarm One: </strong>{detail.AlarmOne}</td></tr>
                            <tr><td><strong>Alarm Two: </strong>{detail.AlarmTwo}</td></tr>
                            <tr><td><strong>Alarm Three: </strong>{detail.AlarmThree}</td></tr>
                            <tr><td><strong>Alarm Four: </strong>{detail.AlarmFour}</td></tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr><td><strong>Type: </strong>{detail.Type}</td></tr>
                            <tr><td><strong>Jockey Sequence: </strong>{getJockeySequence(detail.Zone)}</td></tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p><strong>Comments:</strong><br />{detail.Comments}</p>
                <br className="clearfix" />
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div>
      <h2 className="print-section-header">Sequence of Operations Summary</h2>
      {renderDetails(sequenceDetails)}
    </div>
  );
};

export default PrintSequenceOfOperations;
